import { Link } from "react-router-dom";

export interface RegionPageData {
  heroTitle: string;
  heroDescription: string;
  description: string;
  services: { title: string; path: string; desc: string }[];
  faqs: { question: string; answer: string }[];
  ctaText: string;
  heroImage: string;
}

export default function RegionPage({ data }: { data: RegionPageData }) {
  return (
    <>
      <section className="relative min-h-[360px] md:min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img src={data.heroImage} alt={data.heroTitle} className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(3, 27, 63, 0.85), rgba(3, 27, 63, 0.45))' }}></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="max-w-7xl mx-auto">
            <span className="inline-block bg-[#2EA44F]/90 text-white text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              Hizmet Bölgelerimiz
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
              {data.heroTitle}
            </h1>
            <p className="text-base md:text-lg text-[#EAF2FF] leading-relaxed mb-6 max-w-2xl">
              {data.heroDescription}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href="tel:05539591940" className="inline-flex items-center justify-center gap-2 bg-[#2EA44F] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors whitespace-nowrap">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                Hemen Ara
              </a>
              <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white text-[#0A2F63] px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#EAF2FF] transition-colors whitespace-nowrap">
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                WhatsApp'tan Yaz
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
              {data.description}
            </p>

            <div className="mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                Sunulan Hizmetler
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {data.services.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className="group bg-background-100 rounded-lg p-4 border border-background-200/50 hover:border-primary-300 hover:bg-primary-50/30 transition-all"
                  >
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-sm text-foreground-600">{service.desc}</p>
                  </Link>
                ))}
              </div>
            </div>

            <div className="mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-3">
                {data.faqs.map((faq, i) => (
                  <div key={i} className="bg-background-100 rounded-lg p-4">
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">
                      {faq.question}
                    </h3>
                    <p className="text-sm text-foreground-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#0A2F63] rounded-lg p-6 md:p-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
                {data.ctaText}
              </h2>
              <p className="text-sm text-[#EAF2FF]/90 mb-4">
                Day Temizlik Adana ile ihtiyacınıza uygun hizmet planı için hemen iletişime geçin.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a href="tel:05539591940" className="inline-flex items-center justify-center gap-2 bg-[#2EA44F] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors whitespace-nowrap">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  Hemen Ara
                </a>
                <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white text-[#0A2F63] px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#EAF2FF] transition-colors whitespace-nowrap">
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                  WhatsApp'tan Yaz
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}